import { useCallback, useEffect, useMemo } from "react";
import { TapTracker } from "components/UI/TapTracker";
import { IGif } from "@/common/services/types";
import { dateTimeHR } from "@/common/utils/dates";
import "./ImageGif.scss";

interface IImageGifProps {
  gif: IGif;
  onLike: () => void;
  isVisible: boolean;
  sendGifView: (gif: IGif) => void;
}

export const ImageGif = ({
  onLike,
  gif,
  isVisible,
  sendGifView,
}: IImageGifProps) => {
  const createdAt = dateTimeHR(gif.createDate);
  const altText = `${gif.tags.slice(0, 3).join(", ")} porn ${gif.id} uploaded by ${gif.userName} on ${createdAt}`;

  const handleTapAction = useCallback((clicks: number) => {
    if (clicks === 2) {
      onLike();
    }
  }, [onLike]);

  const imageUrl = useMemo(
    () => (gif.urls.hd ?? gif.urls.sd),
    [gif]
  );

  useEffect(() => {
    if (isVisible) {
      sendGifView(gif);
    }
  }, [isVisible]);

  return (
    <TapTracker onTap={handleTapAction}>
      <div className="ImageGif">
        <img
          src={imageUrl}
          className="ImageGif-Thumbnail"
          alt={altText}
          style={{ aspectRatio: `${gif.width} / ${gif.height}` }}
        />
      </div>
    </TapTracker>
  );
};
